import { render, staticRenderFns } from "./ProfileActionRequest.vue?vue&type=template&id=02031d70&"
import script from "./ProfileActionRequest.vue?vue&type=script&lang=js&"
export * from "./ProfileActionRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports